export const RestoreDetailedDeclarationStatus = [
  { label: 'message.searchCommon.all', isInternationalization: true, value: '' },
  { label: 'message.status.processing', value: 'I' },
  { label: 'message.status.succeed', value: 'S' },
  { label: 'message.status.succeedPartial', value: 'PS' },
  { label: 'message.status.fail', value: 'F' },
];
